export function removeInvisibleChar(string: string) {
  return string.replace(/[\u200B-\u200D\uFEFF\r\n]/g, "");
}

export function pluralizeDocument(num: number, word: string) {
  const cases = [2, 0, 1, 1, 1, 2];
  const forms = ["", "а", "ов"];
  const index = num % 100 > 4 && num % 100 < 20 ? 2 : cases[Math.min(num % 10, 5)];
  return word + forms[index];
}

export function extractHashtags(text: string) {
  return text.match(/#([\p{L}\p{N}_]+|\p{sc=Han})/gu) || [];
}

export const parseDelimitedString = (input: string, separators: string[] = [",", ";"]): string[] => {
  const separatorRegex = new RegExp(`[${separators.join("")}]`);

  return input
    .split(separatorRegex)
    .map((item) => item.trim())
    .filter((item) => item.length > 0);
};
